export const LEXICON_MATERIAL_DIALOG_ID = 'lexiconMaterialDialog';

export enum EClasses {
    IS_LOADING = 'is-loading',
    LEXICON_MATERIAL_REFERENCE_LINK = 'lexicon-material-reference-link',
    LEXICON_MATERIAL_LINK = 'lexicon-material-link',
}
